import angular from 'angular';
import template from './talentExpertHiringFunnelOverviewView.html';

export class TalentExpertHiringFunnelOverviewComponent {
    /* @ngInject */
    constructor() {
        const talentExpertHiringFunnelOverviewCtrl = this;
        talentExpertHiringFunnelOverviewCtrl.init = function () {

        };

        talentExpertHiringFunnelOverviewCtrl.init();
    }
}

export const TalentExpertHiringFunnelOverviewComponentConfiguration = {
    template,
    controller: TalentExpertHiringFunnelOverviewComponent,
    controllerAs: 'talentExpertHiringFunnelOverviewCtrl',
};

angular
    .module('TALENYA-FE')
    .component('talentExpertHiringFunnelOverviewComponent', TalentExpertHiringFunnelOverviewComponentConfiguration);
